var _title, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNinja = function SvgNinja(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ninja")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 13c-0.010-0.35 0.15-0.69 0.42-0.92 0.75 0.16 1.45 0.47 2.080 0.92 0 0.68-0.56 1.24-1.25 1.24s-1.24-0.55-1.25-1.24zM13.75 13c0.63-0.44 1.33-0.75 2.080-0.91 0.27 0.23 0.43 0.57 0.42 0.91 0 0.7-0.56 1.26-1.25 1.26s-1.25-0.56-1.25-1.26v0zM12 9c-2.77-0.040-5.5 0.65-7.93 2l-0.070 1c0 1.23 0.29 2.44 0.84 3.54 2.37-0.36 4.76-0.54 7.16-0.54s4.79 0.18 7.16 0.54c0.55-1.1 0.84-2.31 0.84-3.54l-0.070-1c-2.43-1.35-5.16-2.040-7.93-2zM12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10c-5.523 0-10-4.477-10-10s4.477-10 10-10z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNinja, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ninja.5777337d.svg";
export { ForwardRef as ReactComponent };